<!-- MAIN WRAPPER
    ================================================== -->
<div class="main-wrapper">
  <!-- HEADER
        ================================================== -->
  <header class="header-style2">
    <div class="top-bar">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-9 col-xs-12">
            <div class="top-bar-info">
              <ul class="ps-0">
                <li>
                  <a [attr.href]="topBarPhone.href">
                    <i class="fas fa-phone"></i>{{ topBarPhone.text }}
                  </a>
                </li>
                <li class="d-none d-sm-inline-block">
                  <a href="mailto:info@redmonkwellness.com">
                    <i class="fas fa-envelope"></i>info@redmonkwellness.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 d-none d-md-block">
            <ul class="top-social-icon ps-0">
              <li>
                <a href="https://www.facebook.com/redmonkwellness" target="_blank"><i class="fab fa-facebook-f"></i></a>
              </li>

              <li>
                <a href="https://www.instagram.com/redmonkwellness/" target="_blank"><i
                    class="fab fa-instagram"></i></a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/red-monk-wellness" target="_blank"><i
                    class="fab fa-linkedin-in"></i></a>
              </li>

              <li>
                <a href="https://www.youtube.com/@redmonkwellness" target="_blank"><i class="fab fa-youtube"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-default border-bottom border-color-light-white">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-12 col-lg-12">
            <div class="menu_area alt-font">
              <nav class="navbar navbar-expand-lg navbar-light p-0">
                <div class="navbar-header navbar-header-custom d-flex">
                  <!-- start logo -->
                  <a routerLink="/home" class="navbar-brand logodefault">
                    <img src="/assets/images/redmonkwellness-logo.png" alt="Red Monk Wellness logo" loading="lazy" />
                  </a>
                  <!-- end logo -->

                  <a routerLink="/home" class="navbar-brand-mobile">
                    <img src="/assets/images/rhinomight-logo-w.png" alt="Red Monk Wellness rhinomight logo"
                      loading="lazy" />
                  </a>
                </div>

                <!-- <div class="navbar-toggler bg-primary"></div> -->

                <button class="navbar-toggler bg-primary" type="button" (click)="toggleMenu()">

                  <!-- <i class="fas fa-bars"></i> -->

                </button>

                <!-- start menu area -->
                <ul class="navbar-nav ms-auto" id="nav" [class.mobile-open]="isMobileMenuOpen">
                  <li><a routerLink="/home">Home </a></li>
                  <li><a routerLink="/treatments">Treatments </a></li>
                  <li><a routerLink="/houseofhydration">Wellness I.V. Therapy </a></li>
                  <li><a routerLink="/timelessmonk"> Beauty I.V. Therapy </a></li>
                  <li>
                    <a href="#">About Us </a>
                    <ul>
                      <li><a routerLink="/aboutus">About us </a></li>
                      <li><a routerLink="/mandavi-s-mishra">Director's Profile </a></li>
                      <li><a routerLink="/ourteam">Our Team </a></li>
                      <li><a routerLink="/howitworks">How it works </a></li>
                      <li><a routerLink="/benefits">Benefits </a></li>
                      <li><a routerLink="/package">Packages </a></li>
                    </ul>
                  </li>
                  <li><a routerLink="/press-media">Press </a></li>
                  <li><a routerLink="/blog">Blogs </a></li>
                  <li><a routerLink="/contactus">Contact </a></li>

                  <!-- 

                  <li>
                    <a href="#">Team </a>
                    <ul>
                      <li><a routerLink="/mandavi-s-mishra">Director's Profile </a></li>
                      <li><a routerLink="/ashim-matthan">Ashim Matthan </a></li>
                      <li><a routerLink="/dr-kanishka-jain">Dr. Kanishk </a></li>
                      <li><a routerLink="/deepak-das">Deepak Kumar Das </a></li>
                    </ul>
                  </li> -->

                  <!-- <li>
                    <a href="#">Our Services </a>
                    <ul>
                      <li>
                        <a href="https://houseofhydration.redmonkwellness.com/Home">House Of Hydration
                        </a>
                      </li>
                      <li>
                        <a href="https://timelessmonk.redmonkwellness.com/Home">Timeless Monk </a>
                      </li>
                    </ul>
                  </li> -->



                  <!-- <li>
                                        <a href="#">Why Us </a>
                                        <ul>
                                            <li><a href="#howitworks">How it works </a></li>
                                            <li><a href="#benefits">Benefits </a></li>
                                        </ul>
                                    </li> -->



                  <li class="d-none d-xl-inline-block pt-btn-10">
                    <a routerLink="/bookconsultation" class="btn-style1 text-white small"><span> Book Consultation
                      </span></a>
                  </li>
                </ul>
                <!-- end menu area -->

                <!-- start attribute navigation -->
                <div class="attr-nav align-items-xl-center ms-xl-auto main-font">
                  <!-- <ul>
                                        <li class="d-none d-xl-inline-block">
                                            <a href="#enquiry" class="btn-style1 text-white small"><span> Enquire Now
                                                </span></a>
                                        </li>
                                    </ul> -->

                  <div class="row align-items-center">
                    <!-- <div class="col-lg-6">
                        <ul>
                          <li class="d-none d-xl-inline-block">
                            <a href="#" class="btn-style1 text-white small"><span> Enquire Now </span></a>
                          </li>


                        </ul>
                      </div> -->

                    <div class="col-lg-12">
                      <div class="d-none d-xl-inline-block">
                        <!-- start logo -->
                        <a routerLink="/home" class="navbar-brand-right">
                          <img src="/assets/images/rhinomight-logo-w.png" alt="Rhinomight logo" loading="lazy" /></a>
                        <!-- end logo -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end attribute navigation -->
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <main class="">
    <!-- Angular Router loads pages here -->
    <router-outlet></router-outlet>
  </main>

  <!-- FOOTER
        ================================================== -->





  <!----New footer start-------->

  <!-- Footer -->
  <footer>
    <!-- Main Footer Content -->
    <div class="main-footer">
      <div class="container">
        <div class="row g-3">
          <!-- Company Info -->
          <div [class]="isContact ? 'col-lg-3' : 'col-lg-4'">
            <div class="footer-logo">
              <span class="snowflake"><img src="/assets/images/Redmonk-Wellness-Logo-w.png" alt="Red Monk Wellness"
                  loading="lazy" /></span>
            </div>
            <p class="text-light">
              IV Therapy is transforming the health and wellness landscape by offering fast, effective solutions
              tailored to a wide range of wellness and cosmetic needs.
            </p>

            <!-- Social Icons -->
            <div class="social-icons mt-4">
              <a href="https://www.facebook.com/redmonkwellness" target="_blank" aria-label="Facebook"><i
                  class="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/redmonkwellness/" target="_blank" aria-label="Instagram"><i
                  class="fab fa-instagram"></i></a>
              <a href="https://www.linkedin.com/company/red-monk-wellness" target="_blank" aria-label="LinkedIn"><i
                  class="fab fa-linkedin-in"></i></a>
              <a href="https://www.youtube.com/@redmonkwellness" target="_blank" aria-label="YouTube"><i
                  class="fab fa-youtube"></i></a>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="col-lg-2 col-md-4">
            <div class="footer-section">
              <h5>Sitemap</h5>
              <ul class="list-unstyled">
                <li><a routerLink="/home" class="quick-link">→ Home</a></li>
                <li><a routerLink="/aboutus" class="quick-link">→ About Us</a></li>
                <li><a routerLink="/treatments" class="quick-link">→ Treatments</a></li>
                <li><a routerLink="/press-media" class="quick-link">→ Press</a></li>
                <li><a routerLink="/blog" class="quick-link">→ Blogs</a></li>
              </ul>
            </div>
          </div>

          <!-- Our Services -->
          <div [class]="isContact ? 'col-lg-2 col-md-4' : 'col-lg-3 col-md-4'">
            <div class="footer-section">
              <h5>Our Services</h5>
              <ul class="list-unstyled">
                @if (!isKolkata) {
                <li><a routerLink="/houseofhydration" class="service-link">→ Wellness I.V. Therapy</a></li>
                <li><a routerLink="/timelessmonk" class="service-link">→ Beauty I.V. Therapy</a></li>
                }
                @if (isKolkata) {
                <li><a routerLink="/kolkata/dermatology-skin-facial-treatments" class="service-link">→ Skin &amp; Facial</a></li>
                <li><a routerLink="/kolkata/hair-treatments-solutions" class="service-link">→ Hair Treatments</a></li>
                <li><a routerLink="/kolkata/laser-treatments" class="service-link">→ Laser Treatments</a></li>
                <li><a routerLink="/kolkata/iv-wellness-beauty" class="service-link">→ IV Wellness &amp; Beauty</a></li>
                <li><a routerLink="/kolkata/physiotherapy" class="service-link">→ Physiotherapy</a></li>
                <li><a routerLink="/kolkata/consultation-wellness-programs" class="service-link">→ Consultation &amp; Wellness Programs</a></li>
                }
                <li><a routerLink="/privacy-policy" class="service-link">→ Privacy Policy</a></li>
                <li><a routerLink="/terms-conditions" class="service-link">→ Terms & Conditions</a></li>
              </ul>
            </div>
          </div>

          <!-- Highlights -->
          <div [class]="isContact ? 'col-lg-2 col-md-4' : 'col-lg-3 col-md-4'">
            <div class="footer-section">
              <h5>Quick links</h5>
              <ul class="list-unstyled">
                <li><a routerLink="/ourteam" class="highlight-link">→ Our Team</a></li>
                <li><a routerLink="/howitworks" class="highlight-link">→ How it works</a></li>
                <li><a routerLink="/benefits" class="highlight-link">→ Benefits</a></li>
                <li><a routerLink="/package" class="highlight-link">→ Packages</a></li>
                <li><a routerLink="/contactus" class="highlight-link">→ Contact Us</a></li>
              </ul>
            </div>
          </div>

          <!-- Our Services in Kolkata (Contact Us page only) -->
          @if (isContact) {
          <div class="col-lg-3 col-md-4">
            <div class="footer-section">
              <h5>Our Services in Kolkata</h5>
              <ul class="list-unstyled">
                <li><a routerLink="/kolkata/dermatology-skin-facial-treatments" class="highlight-link">→ Skin &amp; Facial</a></li>
                <li><a routerLink="/kolkata/hair-treatments-solutions" class="highlight-link">→ Hair Treatments</a></li>
                <li><a routerLink="/kolkata/laser-treatments" class="highlight-link">→ Laser Treatments</a></li>
                <li><a routerLink="/kolkata/iv-wellness-beauty" class="highlight-link">→ IV Wellness &amp; Beauty</a></li>
                <li><a routerLink="/kolkata/physiotherapy" class="highlight-link">→ Physiotherapy</a></li>
                <li><a routerLink="/kolkata/consultation-wellness-programs" class="highlight-link">→ Consultation &amp; Wellness Programs</a></li>
              </ul>
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Bottom Copyright -->
    <div class="copyright py-4 text-center text-dark">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12">
            &copy; 2026 RedMonk Wellness Private Limited. All rights
            reserved. Designed by <span class="text-info"> <a href="https://design-accent.com/"
                class="text-danger text-dark-hover" target="_blank">Design Accent</a></span>



          </div>
        </div>
      </div>
    </div>
  </footer>


  <!--New footer end-->
</div>


<a routerLink="/bookconsultation" class="enquiry-fixed d-block" title="Enquiry">
  <span>Book Consultation</span>
</a>